// ResultsCount.js
import React from 'react';

const ResultsCount = ({ count, wrapperStyle = {}, desktop = false }) => (
  <div style={{
    padding: desktop ? "20px 40px" : "0 20px 10px",
    background: desktop ? "#f8f9fa" : "transparent",
    borderBottom: desktop ? "1px solid #e9ecef" : "1px solid #eee",
    textAlign: "center",
    ...wrapperStyle
  }}>
    <p style={{ margin: 0, fontSize: desktop ? 16 : 14, color: "#666", fontWeight: desktop ? 500 : 400 }}>
      找到 {count} 個結果
    </p>
  </div>
);

export default ResultsCount;